export default __webpack_public_path__ + "static/media/ag_5.69540d69.wav";